export const PUBLIC_LAYOUT = 'public-layout';
export const PRIVATE_LAYOUT = 'private-layout'
